import { memo, useRef, useState } from 'react';
import { useClickAway } from 'react-use';
import { deleteConfirmation } from '../../../utils/helpers';

const normalizeItems = (group) => {
  const fromItemNames = group?.itemNames;
  if (Array.isArray(fromItemNames) && fromItemNames.length > 0) {
    return fromItemNames.map((i) => (typeof i === 'string' ? i : i?.name)).filter(Boolean);
  }
  const fromInvestigations = group?.Investigations;
  if (Array.isArray(fromInvestigations) && fromInvestigations.length > 0) {
    return fromInvestigations.map((i) => (typeof i === 'string' ? i : i?.name)).filter(Boolean);
  }
  const fromItems = group?.items;
  if (Array.isArray(fromItems) && fromItems.length > 0) {
    return fromItems.map((i) => (typeof i === 'string' ? i : i?.name)).filter(Boolean);
  }
  return [];
};

const GroupDropdownItem = ({
  group,
  isSelected,
  onSelect,
  onDelete,
  selectedItems,
  onToggleItem,
}) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const containerRef = useRef(null);
  const items = normalizeItems(group);

  useClickAway(containerRef, () => setShowMenu(false));

  return (
    <div
      ref={containerRef}
      className={`chief-complain-item mp-20${isSelected ? ' is-selected' : ''}`}
      onMouseOver={() => setShowDelete(true)}
      onMouseOut={() => setShowDelete(false)}
    >
      <span className="cursor-pointer" onClick={() => onSelect(group)}>
        {group.name}
      </span>
      <i
        className="fa fa-angle-down arrow-angle cursor-pointer"
        aria-hidden="true"
        onClick={() => setShowMenu((v) => !v)}
      />
      {showMenu && (
        <div className="cc-group-menu">
          {items.length > 0 ? (
            items.map((itemName, idx) => {
              const isItemSelected = selectedItems?.some(
                (c) => c.name === itemName,
              );
              return (
                <div
                  key={idx}
                  className={`cc-dropdown-item${isItemSelected ? ' selected-opt' : ''}`}
                  onClick={() => onToggleItem(itemName)}
                >
                  <input
                    type="checkbox"
                    checked={!!isItemSelected}
                    onChange={() => {}}
                    style={{ marginRight: '8px', cursor: 'pointer' }}
                  />
                  <span style={{ paddingTop: '2px' }}>{itemName}</span>
                </div>
              );
            })
          ) : (
            <div className="cc-dropdown-item" style={{ color: '#aaa', cursor: 'default' }}>
              No items in this group
            </div>
          )}
        </div>
      )}
      <span
        className={showDelete ? 'complain-remove-btn-hover' : 'complain-remove-btn'}
        onClick={() => deleteConfirmation(onDelete, group.id)}
      >
        <i className="fa fa-minus-circle" aria-hidden="true" style={{ fontSize: '14px' }} />
      </span>
    </div>
  );
};

export default memo(GroupDropdownItem);
